var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ windowVisible: _vm.windowVisible },style:({ 'background-image': ("url(" + _vm.iconSrc + ")") }),attrs:{"id":"taskbar-item"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }